import React from 'react';
import PropTypes from 'prop-types';

const Body = ({ title }) => {
  if (title === 'Cancel and refund') {
    return <div className="text-center">Are you sure you want to cancel and refund the child panel order?</div>;
  }

  return null;
};

Body.propTypes = {
  title: PropTypes.string,
};

export default Body;
